import React, { useState, useEffect } from "react";
import axios from "axios";
import "./css/leaderPanel.css";
import ScheduleForm from "./ScheduleForm";
import BellScheduleForm from "./BellScheduleForm";
import EditSchedule from "./EditSchedule";
import config from "../config"; // Импортируем API_URL

const LeaderPanel = () => {
  const [newUserId, setNewUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [groupId, setGroupId] = useState(null);
  const [activeForm, setActiveForm] = useState(null);

  useEffect(() => {
    fetchGroupId();
  }, []);

  const fetchGroupId = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/user_info`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setGroupId(response.data.group_id);
    } catch (error) {
      console.error("Ошибка загрузки группы пользователя:", error);
    }
  };

  const handleAddUser = async () => {
    if (!newUserId.trim()) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${config.API_URL}/group/add_user`,
        { telegram_user_id: newUserId,
          group_id: groupId 
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(response.data.message);
      setNewUserId("");
    } catch (error) {
      console.error("Ошибка добавления пользователя:", error);
      setMessage("Ошибка добавления пользователя");
    }
    setLoading(false);
  };

  const toggleForm = (form) => {
    setActiveForm((prev) => (prev === form ? null : form));
  };

  return (
    <div className={`leader-panel ${activeForm ? "expanded" : ""}`}>
      <h2 className="main-text">Меню старосты</h2>

      <div className="add-user">
        <h3 className="second-text">Добавить пользователя</h3>
        <input
          type="text"
          placeholder="Введите Telegram ID пользователя"
          value={newUserId}
          onChange={(e) => setNewUserId(e.target.value)}
        />
        <button onClick={handleAddUser} disabled={loading} className="toggle-btn add-user-button">
          {loading ? "Добавление..." : "Добавить"}
        </button>
      </div>

      <button className={`toggle-btn ${activeForm === "schedule" ? "active" : ""}`} onClick={() => toggleForm("schedule")}>
        📅 Добавить расписание
      </button>
      <button className={`toggle-btn ${activeForm === "bell" ? "active" : ""}`} onClick={() => toggleForm("bell")}>
        ⏰ Изменить звонки
      </button>
      <button className={`toggle-btn ${activeForm === "edit_schedule" ? "active" : ""}`} onClick={() => toggleForm("edit_schedule")}>
        📝 Редактировать расписание
      </button>

      <div className={`expandable-container ${activeForm ? "open" : ""}`}>
        {activeForm === "schedule" && groupId && (
          <div className="schedule-panel">
            <ScheduleForm
              groupId={groupId}
              onClose={() => setActiveForm(null)}
              onScheduleAdded={() => console.log("Расписание обновлено")}
            />
          </div>
        )}

        {activeForm === "bell" && groupId && (
          <div className="bell-schedule-panel">
            <BellScheduleForm groupId={groupId} onClose={() => setActiveForm(null)} />
          </div>
        )}

        {activeForm === "edit_schedule" && groupId && (
          <div className="edit-schedule-panel">
            <EditSchedule groupId={groupId} onClose={() => setActiveForm(null)} />
          </div>
        )}
      </div>

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default LeaderPanel;
